import styled, { css } from 'styled-components';
import { rgba } from 'polished';

// Import styles
import { transitionMain } from 'components/styles';

export const SelectContainer = styled.div<{ isError?: boolean }>`
	width: 100%;

	.select__control {
		width: 100%;
		height: 5rem;
		position: relative;
		padding: 0 1.4rem;
		border: 1px solid ${({ theme, isError }) => (isError ? theme.form.color.error : rgba(theme.form.color.primary, 0.2))};
		border-radius: 0.4rem;
		background: transparent;
		outline: none;
		font-size: 1.6rem;
		color: ${({ theme }) => theme.form.color.primary};
		font-weight: ${({ theme }) => theme.font.light};
		cursor: pointer;

		&--menu-is-open {
			border-color: ${({ theme }) => theme.form.color.highlight} !important;
		}

		&:disabled {
			background: ${({ theme }) => rgba(theme.form.color.primary, 0.03)};
		}
	}

	.select__input-container {
		color: ${({ theme }) => theme.form.color.primary};
	}

	.select__indicator-separator {
		display: none;
	}

	.select__menu {
		color: magenta;
		background-color: ${({ theme }) => theme.form.bg.secondary};
		border: 1px solid ${({ theme }) => rgba(theme.form.color.primary, 0.2)};
		font-weight: ${({ theme }) => theme.font.light};
		border-radius: 0.4rem;
	}

	.select__option {
		color: ${({ theme }) => rgba(theme.form.color.primary, 0.8)};
		padding: 1.4rem;
		cursor: pointer;

		&:hover {
			color: ${({ theme }) => theme.form.color.primary};
			background: ${({ theme }) => rgba(theme.form.color.primary, 0.07)};
		}

		&--is-selected {
			background: ${({ theme }) => rgba(theme.form.color.primary, 0.1)};

			&:hover {
				background: ${({ theme }) => rgba(theme.form.color.primary, 0.1)};
				color: ${({ theme }) => rgba(theme.form.color.primary, 0.8)};
			}
		}
	}
`;

export const Label = styled.label<{ $transform?: boolean; isError?: boolean }>`
	position: absolute;
	z-index: 2;
	transform: translateY(50%);
	left: 0;
	padding-left: 1.2rem;
	font-size: 1.6rem;
	color: ${({ theme }) => rgba(theme.form.color.primary, 0.6)};
	font-weight: ${({ theme }) => theme.font.light};
	pointer-events: none;
	${transitionMain}

	${({ $transform }) =>
		$transform &&
		css`
			padding: 0 0.5rem;
			transform: translateX(1rem) translateY(-0.8rem);
			background-color: ${({ theme }) => theme.form.bg.primary};
			font-size: 1.2rem;
			font-weight: ${({ theme }) => theme.font.normal};
			color: ${({ theme, isError }) => (isError ? theme.form.color.error : rgba(theme.form.color.primary, 0.6))};
		`}
`;
